<template>
  <div class="container">
    <b-card title="Company Call List" class="margin-bottom">
      <div class="row" v-if="filters">
        <div class="col-md-4">
          <strong>Call Criteria</strong>
        </div>
        <div class="col-md-8">
          <div>{{filters.tiers}}</div>
          <div>{{filters.regions}}</div>
          <div>{{filters.postcodes}}</div>
          <div>{{filters.sector}}</div>
          <div>{{filters.subSector}}</div>
          <div>{{filters.tags}}</div>
          <div>{{filters.campaigns}}</div>
          <div>{{filters.yearEnd}}</div>
          <div>{{filters.employees}}</div>
        </div>
      </div>

      <div class="row margin-top">
        <div class="col-md-4">
          <strong>Remaining Companies</strong>
        </div>
        <div class="col-md-8" v-if="callCount != null">
          <div v-if="callCount != 1">{{callCount}} companies remaining</div>
          <div v-if="callCount == 1">{{callCount}} company remaining</div>
        </div>
      </div>

      <div class="row margin-top">
        <div class="col-md-4"></div>
        <div class="col-md-8">
          <b-button type="button" variant="primary" :disabled="!callCount || callCount == 0" @click="nextCompany">
            <font-awesome-icon icon="play-circle" /> Get Next
          </b-button>
        </div>
      </div>

    </b-card>
  </div>
</template>

<script>
import DataSelectionService from "@/services/DataSelection.service";

export default {
  created() {
    DataSelectionService.count().then((result) => {
      this.callCount = result.data;
    });

    DataSelectionService.getFilters().then((result) => {
      this.filters = result.data;
    });
  },
  data() {
    return {
      callCount: null,
      filters: null,
    };
  },
  methods: {

    nextCompany() {
      DataSelectionService.getNextCompany().then(result => {
        if(result && result.data != 0) {
          this.$router.push("/company/" + result.data + "/call");
        }
      });
    }
  }
};
</script>
